import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoute() {
  const token = localStorage.getItem("token"); // 或从 Redux/Context 中取

  // 如果有 token，放行；否则跳转到登录页
  return token ? <Outlet /> : <Navigate to="/login" replace />;
}
